"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _helpers = require("react-platform-components/dist/helpers");
var _config = require("../config");
var _lodash = _interopRequireDefault(require("lodash"));
var _Link = require("react-platform-components/dist/Link/Link");
var _Translations = require("react-platform-components/dist/Translations");
var _reactUse = require("react-use");
var _LoadingPage = require("react-platform-components/dist/components/LoadingPage");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    text: {
      color: 'black',
      fontSize: '15px'
    },
    deleteIcon: {
      background: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.third.secondary
      },
      width: '30px',
      height: '30px'
    },
    cardMediaImage: {
      backgroundSize: theme.palette.custom.bookmarkOfProductbackgroundImageSize || 'cover',
      height: 250
    }
  };
});
var BookmarksList = function BookmarksList(props) {
  (0, _reactUse.useTitle)(props.intl.formatMessage({
    id: "BookmarkOfProductList title",
    defaultMessage: "BookmarkOfProductList title"
  }));
  var classes = useStyles();
  var products = props.products,
    openConfirmDialog = props.openConfirmDialog,
    inProgress = props.inProgress;
  if (inProgress) {
    return /*#__PURE__*/_react.default.createElement(_LoadingPage.LoadingPage, null);
  }
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    style: {
      padding: '2rem'
    },
    container: true,
    spacing: 2
  }, products.map(function (bookmark, index) {
    var _bookmark$product$mai, _bookmark$product;
    var mainImage = (_bookmark$product$mai = bookmark.product.main_image) === null || _bookmark$product$mai === void 0 ? void 0 : _bookmark$product$mai.name["500x500"];
    var image = mainImage && !_lodash.default.isEmpty(mainImage) ? (0, _helpers.joinPaths)(_config.BASE_URL, mainImage) : bookmark.product.images && bookmark.product.images.length > 0 ? (0, _helpers.joinPaths)(_config.BASE_URL, bookmark.product.images[0].url) : "".concat(_config.STATIC_PATH, "/assets/images/backgrounds/header-bg.png");
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      key: index,
      item: true,
      md: 6,
      xs: 12,
      lg: 4
    }, /*#__PURE__*/_react.default.createElement(_core.Card, {
      className: "h-full"
    }, /*#__PURE__*/_react.default.createElement(_Link.Link, {
      to: "".concat(_config.PRODUCTS_ENDPOINT, "/").concat(bookmark.product.id),
      base: _config.BASE_URL,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "no-underline"
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.CardMedia, {
      className: classes.cardMediaImage,
      image: image
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      style: {
        position: 'absolute'
      },
      item: true,
      container: true,
      alignItems: "center",
      justify: "flex-end"
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      onClick: function onClick(event) {
        event.preventDefault();
        openConfirmDialog(bookmark)();
      },
      style: {
        color: "beige"
      },
      className: classes.deleteIcon
    }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "clear"))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.CardContent, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      alignItems: "center",
      xs: 10
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.text,
      variant: "overline"
    }, bookmark.product.name)), !_lodash.default.isEmpty((_bookmark$product = bookmark.product) === null || _bookmark$product === void 0 ? void 0 : _bookmark$product.price) && /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      style: {
        height: 'auto'
      },
      className: "text-gray-700",
      variant: "body2"
    }, bookmark.product.price, " ", /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "\u20AC",
      defaultMessage: "\u20AC"
    }))))))))));
  }));
};
var _default = (0, _Translations.injectIntl)(BookmarksList);
exports.default = _default;